import axios from "axios";
import { auth, getFullHttpUrl } from "../firebase.config";
import { EAST4 } from "./enums";

// Signing in with a code sent by email (functions SignIn/index.js): for
// people who don't remember their password, from any sign-in on the site.

// Off until the functions are deployed where the site runs
// (REACT_APP_SIGN_IN_CODE=true in its env file): the sign-in window then
// offers the code, and the checkout says when an email has an account.
export const signInCodeEnabled = process.env.REACT_APP_SIGN_IN_CODE === "true";

// Whether the email has an account that can sign in (the checkout's "You
// have an account" for guests). False when it can't tell.
export const emailHasAccount = async (email) => {
  try {
    const res = await axios.post(getFullHttpUrl("signIn-hasAccount", EAST4), { email: String(email || "").trim().toLowerCase() });
    return Boolean(res.data && res.data.hasAccount);
  } catch (e) {
    return false;
  }
};

// Emails a 6-digit code (the server answers the same whether or not the
// email has an account). Throws "too-many" when the hour's codes are used up.
export const sendSignInCode = async (email, lang) => {
  try {
    await axios.post(getFullHttpUrl("signIn-sendCode", EAST4), { email: String(email || "").trim().toLowerCase(), lang });
  } catch (e) {
    throw new Error(e && e.response && e.response.status === 429 ? "too-many" : "send-failed");
  }
};

// Checks the code and signs in with it. Resolves to the credential, or
// throws "invalid", "expired", "too-many", "disabled" or "failed".
export const signInWithCode = async (email, code) => {
  let token;
  try {
    const res = await axios.post(getFullHttpUrl("signIn-verifyCode", EAST4), { email: String(email || "").trim().toLowerCase(), code: String(code || "").replace(/\D/g, "") });
    token = res.data && res.data.token;
  } catch (e) {
    const status = e && e.response && e.response.status;
    const data = e && e.response && e.response.data;
    throw new Error(status === 429 ? "too-many" : status === 403 && (data === "invalid" || data === "expired") ? data : "failed");
  }
  if (!token) {
    throw new Error("failed");
  }
  try {
    return await auth.signInWithCustomToken(token);
  } catch (e) {
    throw new Error(e && e.code === "auth/user-disabled" ? "disabled" : "failed");
  }
};
